/** Recadre en 3:2 et compresse côté client avant upload (évite les 413 Cloudflare/nginx). */

const RATIO_W = 3;
const RATIO_H = 2;
const MAX_W = 480;
const JPEG_QUALITY = 0.88;

export async function prepareEmpireFlagFile(file: File): Promise<File> {
  if (!file.type.startsWith('image/')) {
    throw new Error('Fichier image requis (PNG, JPEG ou WebP).');
  }
  // Source trop énorme même pour le canvas
  if (file.size > 40 * 1024 * 1024) {
    throw new Error('Image trop lourde (max 40 Mo avant compression).');
  }

  const bitmap = await createImageBitmap(file);
  try {
    const w = bitmap.width;
    const h = bitmap.height;
    if (w < 16 || h < 16) {
      throw new Error('Image trop petite.');
    }
    const targetRatio = RATIO_W / RATIO_H;
    const srcRatio = w / h;
    let sx: number;
    let sy: number;
    let sw: number;
    let sh: number;
    if (srcRatio > targetRatio) {
      sh = h;
      sw = Math.round(h * targetRatio);
      sx = Math.floor((w - sw) / 2);
      sy = 0;
    } else {
      sw = w;
      sh = Math.round(w / targetRatio);
      sx = 0;
      sy = Math.floor((h - sh) / 2);
    }
    let outW = Math.min(MAX_W, sw);
    outW = Math.max(RATIO_W, outW - (outW % RATIO_W));
    const outH = Math.round((outW * RATIO_H) / RATIO_W);

    const canvas = document.createElement('canvas');
    canvas.width = outW;
    canvas.height = outH;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas indisponible.');
    ctx.drawImage(bitmap, sx, sy, sw, sh, 0, 0, outW, outH);

    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (b) => (b ? resolve(b) : reject(new Error('Compression impossible.'))),
        'image/jpeg',
        JPEG_QUALITY,
      );
    });

    return new File([blob], 'empire-flag.jpg', { type: 'image/jpeg', lastModified: Date.now() });
  } finally {
    bitmap.close();
  }
}
